import { l } from '@locale/setupI18n';
import { DateDisambiguation, Denomination } from '../models/contracts/enums/shared-enums';
import { enumKeyByValue } from '../helpers';

export const getDisambiguationLabel = (disambiguation: DateDisambiguation): string => {
  if (disambiguation === DateDisambiguation.StartOfDay) {
    return l('_StartOfDay');
  }
  if (disambiguation === DateDisambiguation.EndOfDay) {
    return l('_EndOfDay');
  }
  return '';
};

export const getSharesLabel = (denomination: keyof typeof Denomination) =>
  denomination === enumKeyByValue(Denomination, Denomination.Units)
    ? l('_SharesNumber')
    : l('_SharesByDenomination', { denomination: Denomination[denomination] });

export const getCountWithDenomination = (denomination: keyof typeof Denomination) =>
  denomination === enumKeyByValue(Denomination, Denomination.Units)
    ? l('_CountSymbol')
    : l('_CountSymbolWithDenomination', {
        denomination: Denomination[denomination],
      });
